module.exports = __webpack_public_path__ + "img/star-3.8cac5ddb.svg";